import { fokaAxios } from 'app/fokaAxios'
import { BizChannelTypes } from '../../../features/Codes'
import { sortCreativeResponse } from '../../../features/creative/creativeUtil'

const BizChannelTypePaths = {
  [BizChannelTypes.WEBSITE_BIZ_CHANNEL]: 'basic',
  [BizChannelTypes.TALK_CHANNEL]: 'talkChannel',
}
export default {
  getCreatives: ({
    creativeStatus,
    reviewStatus,
    bizChannelIds,
    page,
    size,
    sort,
  }) =>
    fokaAxios.post(
      '/api/v2/creatives/list',
      {
        ...(creativeStatus &&
          creativeStatus.length !== 0 && { status: creativeStatus }),
        ...(reviewStatus && reviewStatus.length !== 0 && { reviewStatus }),
        ...(bizChannelIds && bizChannelIds.length !== 0 && { bizChannelIds }),
      },
      {
        params: {
          page,
          limit: size,
          sort,
        },
      }
    ),
  getCreative: async id => {
    const response = await fokaAxios.get(`/api/v2/creatives/${id}`)
    return sortCreativeResponse(response)
  },
  deleteCreatives: ({ ids }) =>
    fokaAxios.delete('/api/v2/creatives', { data: { ids } }),
  addCreative: ({ bizChannelType, ...createBasicCreativeCommand }) =>
    fokaAxios.post(
      `/api/v2/creatives/${BizChannelTypePaths[bizChannelType]}`,
      createBasicCreativeCommand
    ),
  saveAsCreative: ({ bizChannelType, ...createEditedBasicCreativeCommand }) =>
    fokaAxios.post(
      `/api/v2/creatives/${BizChannelTypePaths[bizChannelType]}/edited`,
      createEditedBasicCreativeCommand
    ),
  getAdGroupsByCreative: id =>
    fokaAxios.get(`/api/v2/creatives/${id}/adgroups`),
  getCreativeIsAddable: bizChannelId =>
    fokaAxios.get('/api/v2/creatives/generable', { params: { bizChannelId } }),
  getReviewReason: creativeId =>
    fokaAxios.get(`/api/v2/creatives/${creativeId}/review/reason`),
}
